import React, { useState } from 'react'
import { TaxRateIcon } from '../../Assets/AllSvg'
import { BiRightArrowAlt } from 'react-icons/bi'
import { HiOutlinePlusSm } from 'react-icons/hi'
import AddTaxRateModal from '../AddTaxRateModal/AddTaxRateModal'

const ProductsTaxRates = () => {
    const [addTaxRate, setAddTaxRate] = useState(false)

    const handleAddtaxrate = () => {
        setAddTaxRate(true)
    }

    return (
        <>
            <div>
                <div className='h-[564px] flex items-center justify-center'>
                    <div className="p-[64px]">
                        <div className='p-[12px] w-max rounded-[8px] bg-[#f6f8fa]'>
                            <TaxRateIcon className="fill-gray-500 w-[23px] h-[23px]" />
                        </div>
                        <div className="mt-6">
                            <span className="text-[20px] font-bold text-[#1a1b25]">No test tax rates</span>
                        </div>
                        <p className="text-sm text-[#687385] max-w-[389px] flex-wrap mt-1">Apply manual test tax rates to invoices, subscriptions, and one-time payments or subscriptions created through Stripe Checkout.</p>
                        <button className="text-[#625afa] mt-1 flex items-center font-medium gap-1 text-sm">
                            Learn more
                            <BiRightArrowAlt className='text-[20px] translate-y-[2px]' />
                        </button>
                        <button onClick={handleAddtaxrate} className="flex gap-1 mt-5 text-white font-semibold h-[30px] bg-[#635bff] rounded-[6px] text-[14px] items-center p-[4px_8px]"><HiOutlinePlusSm className="text-[22px]" />Add a test tex rate</button>
                    </div>
                </div>
            </div>
            <AddTaxRateModal addTaxRate={addTaxRate} setAddTaxRate={setAddTaxRate} />
        </>
    )
}

export default ProductsTaxRates